/************ CONSTANTS ***********/
export const CURRENCY = '$';
